/* eslint-disable react/prop-types */
import { createContext, useContext, useState } from 'react';

const LogoutContext = createContext();

export function LogoutProvider({ children }) {
  const [isLogoutDialogOpen, setIsLogoutDialogOpen] = useState(false);

  const openLogoutDialog = () => setIsLogoutDialogOpen(true);
  const closeLogoutDialog = () => setIsLogoutDialogOpen(false);

  return (
    <LogoutContext.Provider value={{ isLogoutDialogOpen, openLogoutDialog, closeLogoutDialog }}>
      {children}
    </LogoutContext.Provider>
  );
}

export function useLogout() {
  return useContext(LogoutContext);
} 